import { Image } from 'antd';
import { useTranslation } from 'react-i18next';
import { ClaimEvidence } from '@/types';

interface EvidenceGalleryProps {
  evidence: ClaimEvidence[];
}

const EvidenceGallery = ({ evidence }: EvidenceGalleryProps) => {
  const { t } = useTranslation();

  if (evidence.length === 0) {
    return (
      <span className="text-sm text-[rgb(115,123,140)]">
        {String(t('no_evidence', { defaultValue: 'No evidence' }))}
      </span>
    );
  }

  const images = evidence.filter((item) => !item.type?.startsWith('video/'));
  const videos = evidence.filter((item) => item.type?.startsWith('video/'));

  return (
    <div className="flex flex-col gap-3">
      {images.length > 0 && (
        <Image.PreviewGroup>
          <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
            {images.map((item) => (
              <Image
                key={item.uid}
                src={item.url}
                alt={item.filename}
                width={120}
                height={120}
                className="rounded-lg object-cover"
                wrapperClassName="overflow-hidden rounded-lg"
              />
            ))}
          </div>
        </Image.PreviewGroup>
      )}
      {videos.length > 0 && (
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
          {videos.map((item) => (
            <video
              key={item.uid}
              src={item.url}
              controls
              className="w-full rounded-lg"
              style={{ maxHeight: 200 }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default EvidenceGallery;
